import { Text, VStack } from '@genial/components';
import { Menu } from 'native-base';
import React from 'react';

import { CustomerGlobalSearchResponseNormalized } from '../../../../../../../store/customer/types';

interface CustomerSearchResultsProps {
  items: CustomerGlobalSearchResponseNormalized[];
  selectedCustomer?: CustomerGlobalSearchResponseNormalized;
  isOpen: boolean;
  onClose: () => void;
  menuWidth: number;
  showNotFoundMessage: boolean;
  onSelectCustomer: (customer: CustomerGlobalSearchResponseNormalized) => void;
  onClearSearch: () => void;
}

export const CustomerSearchResults: React.FC<CustomerSearchResultsProps> = ({
  items,
  selectedCustomer,
  isOpen,
  onClose,
  menuWidth,
  showNotFoundMessage,
  onSelectCustomer,
  onClearSearch,
}) => {
  const shouldShowCustomerItems = items.length > 0 && !selectedCustomer;
  const shouldShowNotFound = showNotFoundMessage && !selectedCustomer;

  if (!isOpen || (!shouldShowCustomerItems && !shouldShowNotFound)) {
    return null;
  }

  return (
    <Menu
      borderRadius="sm"
      onClose={onClose}
      trigger={(triggerProps) => <VStack {...triggerProps} w={menuWidth || '100%'} h={0} />}
      placement="bottom left"
      isOpen={isOpen}
      style={{ width: menuWidth || '100%' }}
      closeOnSelect>
      {shouldShowCustomerItems && (
        <>
          {items.map((customer, index) => {
            return (
              <Menu.Item
                key={`${customer.accountId}-${index}`}
                onPress={() => onSelectCustomer(customer)}
                _focus={{ bg: 'brand.tertiary.lightest' }}
                _hover={{ bg: 'brand.tertiary.lightest' }}
                p={0}
                style={{ width: menuWidth || '100%', outline: 'none' }}>
                <VStack p="inset.nano">
                  <Text>{customer.customerNameNormalized}</Text>
                  <Text color="neutral.medium" fontSize="xs">
                    Conta de custódia {customer.custodyAccountNormalized}
                  </Text>
                </VStack>
              </Menu.Item>
            );
          })}
        </>
      )}

      {shouldShowNotFound && (
        <Menu.Item
          onPress={onClearSearch}
          _focus={{ bg: 'background' }}
          _hover={{ bg: 'background' }}
          p={0}
          style={{ width: menuWidth || '100%', outline: 'none' }}>
          <VStack p="inset.nano" borderRadius="sm">
            <Text variant="semibold">Nenhum resultado corresponde à sua pesquisa.</Text>
            <Text>Verifique seu nível de acesso e tente novamente.</Text>
          </VStack>
        </Menu.Item>
      )}
    </Menu>
  );
};
